import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate} from 'react-router-dom';
import { carsData } from '../../../data';
import air from '../../../images/air.png'
import { Container, Card, Button, Form , Col, Row, } from 'react-bootstrap';

import AppContext from '../../../AppContext';


const AvailableCars = () => {
  const [cars, setCars] = useState(carsData);
  const {  selectedPickUpDate, selectedPickUpTime } = useContext(AppContext);
  const [filteredCars, setFilteredCars] = useState(carsData);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const navigate= useNavigate()
  
  const [minAmount, setMinAmount] = useState(10000);
  const [maxAmount, setMaxAmount] = useState(50000);
  const [selectedCarOption, setSelectedCarOption] = useState('');

  
 
  


  useEffect(() => {
    const updatedFilterByAmount = carsData.filter(
      (car) => car.amount >= minAmount && car.amount <= maxAmount
    );
    setFilteredCars(updatedFilterByAmount);
    setSelectedCarOption('')
  }, [minAmount, maxAmount]);

  const handleMinAmountChange = (e) => {
    setMinAmount(parseInt(e.target.value));
  };
 
  const handleMaxAmountChange = (e) => {
    setMaxAmount(parseInt(e.target.value));
  };
  const handleClearAmount = () => {
    setMinAmount(10000);
    setMaxAmount(50000);
  };
  
  const filterByCheapest = () => {
    const sortedCars = [...carsData].sort((a, b) => a.amount - b.amount);
    setFilteredCars(sortedCars);
    setSelectedFilter('cheapest');
  };
  const formatDateToWords = (date) => {
    const options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    
    return date.toLocaleDateString(undefined, options);
  };
  const filterByAll = () => {
    
    setFilteredCars(carsData);
    setSelectedFilter('all');
  };

  const filterCarBrand = (option) => {
    setSelectedCarOption(option);
    let filteredCars = [];

    if (option === 'all') {
      filteredCars = carsData;
    } else if (option === 'mercedesBenz') {
      filteredCars = carsData.filter((car) => car.carBrand === 'Mercedes Benz');
    } else if (option === 'toyota') {
      filteredCars = carsData.filter((car) => car.carBrand.includes('Toyota'));
    } else if (option === 'infinity') {
      filteredCars = carsData.filter((car) => car.carBrand.includes('Infinity'));
    } 

    setFilteredCars(filteredCars);
    handleClearAmount()

  };

  const handleClear = () => {
    
    setFilteredCars(carsData);
    
    setSelectedCarOption('')
    handleClearAmount()
  
  };


  
  const handleSelectCar = (carsId) => {
  
    navigate(`/car-itinerary/${carsId}`);
  };
  return (
    <div  className='' >
    <Card className='border-0  car-container d-none d-md-block'>
          <Card.Img src={air} alt='air' style={{maxHeight:'500px'}} className=''/>
        
        
        <Card.ImgOverlay  className='p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2 '>
            <div className=''>
              <div className='d-block d-md-none'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

              </div>
              </div>
              <div className='d-none d-md-block'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

              </div>
              </div>
              
              <div className='mt-5'>
                <Row className=''>
                  <Col xs={12} md={12} lg={4}>
                  <div className='' style={{background:'#fafafa'}}>
                    <div className='d-flex p-3 justify-content-between align-items-center'>
                        <h5>Filter</h5>
                        <p onClick={handleClear}className='forgot-password' >Clear</p>
                        
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                   
                    <div className='p-3 '>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h5>Price</h5>
                        <p onClick={handleClearAmount}className='forgot-password' >Clear</p>
                        
                    </div>
                    <Form className='d-flex' >
         
                    <Form.Group>
          
          <Form.Range 
            min="10000"
            max="50000"
            step="5000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="10000"
            max="50000"
            step="5000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
        </Form>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                        <h5>Car Brand</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check type="checkbox"
        id="allCheckbox"
        label="All"
        checked={selectedCarOption === 'all'}
        onChange={() => filterCarBrand('all')} />
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="mercedesBenzCheckbox"
        label="Mercedes Benz"
        checked={selectedCarOption === 'mercedesBenz'}
        onChange={() => filterCarBrand('mercedesBenz')}/>
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="toyotaCheckbox"
        label="Toyota"
        checked={selectedCarOption === 'toyota'}
        onChange={() => filterCarBrand('toyota')} />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="infinityCheckbox"
        label="Infinity"
        checked={selectedCarOption === 'infinity'}
        onChange={() => filterCarBrand('infinity')} />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                   
                  </div>
                  </Col>
                  <Col>
                  <div className='mt-3 mt-lg-0'>
                  <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                    
                        </div>
                      </div>
                    <div className=''>
                        {
                          filteredCars.map((cars) => {
                            const {id,
                              icon,
                             carBrand,
                            seats,
                              amount,
                        
                          } = cars;
                          return (
                            <Row className='gap-2 mb-4 mb-md-2' key={id}>
                              <Col className=' ' md={8} style={{background:'#fafafa'}} >

                               <Row className='gap-0 gap-xl-0 gap-sm-4'>
                              
                                <Col xs={12} sm={4} className='p-0 m-0'>
                                <img src={icon} className='hotel-image'  />
                                </Col>
                                <Col>
                                <div className='py-2 ps-0 ps-xxl-0  ps-md-5'>
                              <h2 className='hotel-name'>{carBrand}</h2>
                              <div className='d-flex mb-2'>
                                {seats} &nbsp;seats
                           </div>
      <div className='d-block gap-2 align-items-center mb-2'>
      <p className='
      'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{formatDateToWords(selectedPickUpDate)}</p><p className='
      'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{selectedPickUpTime}</p></div>
      
                                </div>
                                </Col>
                               </Row>
                              </Col>
                              <Col className='align-items-center justify-content-center text-center px-2 py-3' style={{background:'#fafafa'}}>
                              <div className='d-flex justify-content-center'>
                              <p>NGN</p>
     &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                              </div>
                              <p>per day</p>
                              <div className='mb-2'>
                              <Button onClick={() => handleSelectCar(cars.id)} style={{height: '35px',
width: '90px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      Book
      </Button>
                              </div>
                             
                              </Col>
                            </Row>
                          )
                          })
                        }
                    </div>
                  </div>
                  </Col>
                </Row>
              </div>
            </div>
        </Card.ImgOverlay>
       
        </Card>
        <div  className='d-block d-md-none mb-5 p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2 '>
        <div className=''>
              <div className='d-block d-md-none'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

              </div>
              </div>
              <div className='d-none d-md-block'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

              </div>
              </div>
              
              <div className='mt-5'>
                <Row className=''>
                  <Col xs={12} md={12} lg={4}>
                  <div className='' style={{background:'#fafafa'}}>
                    <div className='d-flex p-3 justify-content-between align-items-center'>
                        <h5>Filter</h5>
                        <p onClick={handleClear}className='forgot-password' >Clear</p>
                        
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                   
                    <div className='p-3 '>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h5>Price</h5>
                        <p onClick={handleClearAmount}className='forgot-password' >Clear</p>
                        
                    </div>
                    <Form className='d-flex' >
         
                    <Form.Group>
          
          <Form.Range 
            min="10000"
            max="50000"
            step="5000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="10000"
            max="50000"
            step="5000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
        </Form>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                        <h5>Car Brand</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check type="checkbox"
        id="allCheckbox"
        label="All"
        checked={selectedCarOption === 'all'}
        onChange={() => filterCarBrand('all')} />
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="mercedesBenzCheckbox"
        label="Mercedes Benz"
        checked={selectedCarOption === 'mercedesBenz'}
        onChange={() => filterCarBrand('mercedesBenz')}/>
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="toyotaCheckbox"
        label="Toyota"
        checked={selectedCarOption === 'toyota'}
        onChange={() => filterCarBrand('toyota')} />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="infinityCheckbox"
        label="Infinity"
        checked={selectedCarOption === 'infinity'}
        onChange={() => filterCarBrand('infinity')} />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                   
                  </div>
                  </Col>
                  <Col>
                  <div className='mt-3 mt-lg-0'>
                  <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                    
                        </div>
                      </div>
                    <div className=''>
                        {
                          filteredCars.map((cars) => {
                            const {id,
                              icon,
                             carBrand,
                            seats,
                              amount,
                        
                          } = cars;
                          return (
                            <Row className='gap-2 mb-4 mb-md-2' key={id}>
                              <Col className=' ' md={8} style={{background:'#fafafa'}} >

                               <Row className='gap-0 gap-xl-0 gap-sm-4'>
                              
                                <Col xs={12} sm={4} className='p-0 m-0'>
                                <img src={icon} className='hotel-image'  />
                                </Col>
                                <Col>
                                <div className='py-2 ps-0 ps-xxl-0  ps-md-5'>
                              <h2 className='hotel-name'>{carBrand}</h2>
                              <div className='d-flex mb-2'>
                                {seats} &nbsp;seats
                           </div>
      <div className='d-block gap-2 align-items-center mb-2'>
      <p className='
      'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{formatDateToWords(selectedPickUpDate)}</p><p className='
      'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{selectedPickUpTime}</p></div>
      
                                </div>
                                </Col>
                               </Row>
                              </Col>
                              <Col className='align-items-center justify-content-center text-center px-2 py-3' style={{background:'#fafafa'}}>
                              <div className='d-flex justify-content-center'>
                              <p>NGN</p>
     &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                              </div>
                              <p>per day</p>
                              <div className='mb-2'>
                              <Button onClick={() => handleSelectCar(cars.id)} style={{height: '35px',
width: '90px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      Book
      </Button>
                              </div>
                             
                              </Col>
                            </Row>
                          )
                          })
                        }
                    </div>
                  </div>
                  </Col>
                </Row>
              </div>
            </div>
        </div>
       
  </div>
  )
}

export default AvailableCars
